import React from 'react';

import PropTypes from 'prop-types';
import cx from 'classnames';

import './PaypalCheckoutButton.scss';

const PaypalCheckoutButton = props => {
  return (
    <div
      id="paypal-buttons-container"
      className={cx('paypal-buttons-container', {
        'paypal-buttons-container--submitting': props.isSubmitting
      })}
    />
  );
};

PaypalCheckoutButton.propTypes = {
  isSubmitting: PropTypes.bool
};

export default PaypalCheckoutButton;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/PaypalCheckoutButton/PaypalCheckoutButton.js